import Close from '@components/icons/Close/Close'
import FilterCheckbox from '@components/modules/ProductGrid/Filter/FilterCheckbox'
import { UrlFilter } from '@components/modules/ProductGrid/Filter/filtering'
import Button from '@components/ui/ButtonV2/Button'
import { StockToggle } from '@components/ui/Toggle/Toggle'
import { fixedClearAllBodyScrollLocks } from '@lib/fixedScrollHelpers'
import { Collection } from '@lib/hooks/productGrid/useFindCollections'
import clsx from 'clsx'
import { useRouter } from 'next/router'
import React, { PropsWithChildren, useRef, useState } from 'react'
import { MdChevronRight } from 'react-icons/md'
import s from './MobileFilterOverlay.module.scss'

interface Props {
  collections: Collection[]
  categories: Collection[]
  types: Collection[]
  designers: Collection[]
  soldOnline: boolean
  queryFilters: UrlFilter[]
  setSoldOnline: (value: boolean) => void
  onChangeQueryFilter: (slug: string, values: Collection[]) => void
}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type MobileFilterOverlayProps = Props & NativeAttrs

const MobileFilterOverlay = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<MobileFilterOverlayProps>
>(
  (
    {
      className,
      children,
      soldOnline,
      collections,
      types,
      designers,
      categories,
      queryFilters,
      setSoldOnline,
      onChangeQueryFilter,
      ...props
    },
    ref,
  ) => {
    const router = useRouter()

    const [filterOpen, setFilterOpen] = useState(false)

    const [openLists, setOpenLists] = useState<string>()
    const contentRef = useRef<HTMLDivElement>(null)

    return (
      <>
        <div
          className={clsx(
            'filterOverlay',
            { [s.open]: filterOpen },
            s.filterOverlay,
          )}
          ref={ref}
          {...props}
          onTransitionEnd={(e) => !filterOpen && fixedClearAllBodyScrollLocks()}
          onClick={(e) =>
            e.target == document.querySelector('.filterOverlay') &&
            setFilterOpen(false)
          }
        >
          <div className={s.container} ref={contentRef}>
            <div className={s.wrapper}>
              <div className="headerTwo select-none mb-3 flex items-center justify-between">
                Filters
                <Close
                  className="cursor-pointer w-8 h-8 p-1"
                  onClick={() => setFilterOpen(false)}
                />
              </div>
              <div className={s.content}>
                <>
                  <StockToggle
                    enabled={soldOnline}
                    onChange={(value: boolean) => {
                      setSoldOnline(value)
                    }}
                  />

                  <br />
                </>

                <div className="optionsContainer">
                  {categories.length > 0 && (
                    <FilterCheckbox
                      onClick={() =>
                        openLists == 'categories'
                          ? setOpenLists('')
                          : setOpenLists('categories')
                      }
                      isListOpen={openLists === 'categories'}
                      name="Category"
                      options={categories}
                      selectedOptions={categories?.filter((tag) =>
                        queryFilters.find(
                          (qf) =>
                            qf.slug == 'categories' &&
                            qf.values.includes(tag.value),
                        ),
                      )}
                      onChange={(options) =>
                        onChangeQueryFilter('categories', options)
                      }
                    />
                  )}

                  <FilterCheckbox
                    onClick={() =>
                      openLists == 'types'
                        ? setOpenLists('')
                        : setOpenLists('types')
                    }
                    isListOpen={openLists === 'types'}
                    name="Type"
                    options={types}
                    selectedOptions={types?.filter((tag) =>
                      queryFilters.find(
                        (qf) =>
                          qf.slug == 'types' && qf.values.includes(tag.value),
                      ),
                    )}
                    onChange={(options) =>
                      onChangeQueryFilter('types', options)
                    }
                  />

                  <FilterCheckbox
                    onClick={() =>
                      openLists == 'collections'
                        ? setOpenLists('')
                        : setOpenLists('collections')
                    }
                    isListOpen={openLists === 'collections'}
                    name="Collection"
                    options={collections}
                    selectedOptions={collections?.filter((tag) =>
                      queryFilters.find(
                        (qf) =>
                          qf.slug == 'collections' &&
                          qf.values.includes(tag.value),
                      ),
                    )}
                    onChange={(options) =>
                      onChangeQueryFilter('collections', options)
                    }
                  />

                  <FilterCheckbox
                    onClick={() =>
                      openLists == 'designers'
                        ? setOpenLists('')
                        : setOpenLists('designers')
                    }
                    isListOpen={openLists === 'designers'}
                    name="Designer"
                    options={designers}
                    selectedOptions={designers?.filter((tag) =>
                      queryFilters.find(
                        (qf) =>
                          qf.slug == 'designers' &&
                          qf.values.includes(tag.value),
                      ),
                    )}
                    onChange={(options) =>
                      onChangeQueryFilter('designers', options)
                    }
                  />
                </div>
              </div>
              <div className={s.buttonsWrapper}>
                <div className={s.buttonsContainer}>
                  <Button
                    variant="primary"
                    size="small"
                    onClick={() => {
                      delete router.query.filters
                      delete router.query.soldOnline
                      router.push(router, undefined, { shallow: true })
                    }}
                  >
                    Clear
                  </Button>
                  <Button
                    variant="secondary"
                    size="small"
                    onClick={() => setFilterOpen(false)}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={s.mobileFilter}>
          <div
            className={clsx(
              {
                [s.filterBy]:
                  (router.query.filters?.length > 0 &&
                    router.query.filters?.includes('.')) ||
                  soldOnline,
              },
              'paragraphOne',
            )}
            onClick={() => setFilterOpen(true)}
          >
            FILTER BY
            <MdChevronRight
              className={clsx('transition-transform ml-1', 'rotate-90')}
            />
          </div>
        </div>
      </>
    )
  },
)

MobileFilterOverlay.displayName = 'MobileFilterOverlay'
export default MobileFilterOverlay
